export default "/images/framework/Badge_07.5c6bb9b8.svg?5c6bb9b8";